// extracted by mini-css-extract-plugin
export default {"sirBorderRadiusM":"5px","sirDPurple":"#352f6e","m":"20px","button":"Button_button__4rKfo","type1":"Button_type1__WZYxR","type2":"Button_type2__WL2Wg"};